import React from "react";
export var ItemChip = function (_a) {
    var chip = _a.chip;
    return (React.createElement("span", { className: "uppercase rounded-full bg-gray-50 text-primary-200 font-semibold text-xxs px-3 py-2 tracking-wider leading-none" }, chip));
};
//# sourceMappingURL=ItemChip.js.map